import { useIsLoggedIn } from "@nf/common";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { MDUp, XSSM } from "../../components";
import { DotsLoader } from "../../components/DotsLoader";

import styles from "./WelcomeScreen.module.scss";

const LoginSplash = dynamic(
  () => import("screens/WelcomeScreen/components/LoginSplash")
);

const InitialWelcome = dynamic(
  () => import("screens/WelcomeScreen/components/InitialWelcome")
);

export const MOBILE_PARAM_SUBSCRIPTIONS = "subscriptions";
export const MOBILE_PARAM_SUBSCRIPTION_VALUE = "active";

export const WelcomeScreen = () => {
  const { query } = useRouter();
  const isLoggedIn = useIsLoggedIn();

  const showViewForSubscribedAccount =
    query[MOBILE_PARAM_SUBSCRIPTIONS] === MOBILE_PARAM_SUBSCRIPTION_VALUE;

  if (!isLoggedIn) {
    return null;
  }

  return (
    <>
      <XSSM>
        {showViewForSubscribedAccount ? <LoginSplash /> : <InitialWelcome />}
      </XSSM>
      <MDUp>
        <div className={styles.loader}>
          <DotsLoader />
        </div>
      </MDUp>
    </>
  );
};

export default WelcomeScreen;
